import { css } from 'styled-components';
import {
  getSpacing, SpacingName, BreakpointQueryName, getTypography, TypographyName, ThemedFunctor,
} from '@doveit/lego';

export const base: ThemedFunctor = ({ theme, $compact }) => css`
  border: 1px solid ${theme.palettes.neutrals.light};
  border-radius: 6px;
  height: 100%;
  background-color: ${theme.palettes.neutrals.lightest};
  box-shadow: ${$compact ? '-0.75rem 0.75rem 0.75rem' : '-1.25rem 1.25rem 1.25rem'} rgba(0,0,0,0.05);
  padding: ${theme.spaceUnits.mobile.MEDIUM};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: flex;
    padding: ${$compact ? theme.spaceUnits.desktop.SMALL : theme.spaceUnits.desktop.MEDIUM};
  }
`;

export const confBox = css`
  flex-grow: 1;
`;

export const savingBox: ThemedFunctor = ({ theme, $compact }) => css`
  padding-top: ${theme.spaceUnits.mobile.MEDIUM};
  position: relative;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    padding-left: ${theme.spaceUnits.desktop.SMALL};
    margin-left: ${theme.spaceUnits.desktop.SMALL};
    padding-top: 0;
    display: flex;
    justify-content: center;
    flex-shrink: 0;
    width: ${$compact ? '13' : '19'}rem;

    &::after {
      position: absolute;
      content: '';
      width: 1px;
      top: 0;
      left: 0;
      bottom: 0;
      background-color: ${theme.palettes.neutrals.light};
    }
  }
`;

export const smallLabel: ThemedFunctor = ({ $compact }) => css`
  font-weight: ${$compact ? 'bold' : 'normal'};
  line-height: 1 !important;
`;

export const smallerLabel: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.SMALLER)};
  font-weight: normal;
`;

export const valueBox: ThemedFunctor = ({ theme, $compact }) => css`
  ${getTypography(theme, $compact ? TypographyName.BODY : TypographyName.H4)};
  ${getSpacing.margin(theme, [$compact ? SpacingName.SMALLER : SpacingName.SMALL, 0])};
  display: flex;
  justify-content: space-between;

  &:first-of-type {
    margin-top: 0;
  }
`;

export const label: ThemedFunctor = ({ theme, $compact }) => css`
  ${getTypography(theme, $compact ? TypographyName.BODY : TypographyName.H4)};
  line-height: 1;
  font-weight: normal;
  ${!$compact && 'margin-left: 1rem;'}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    margin-left: 0;
    margin-top: ${theme.spaceUnits.desktop.SMALLER};
    text-align: center;
  }
`;

export const paramValue: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginLeft(theme, SpacingName.SMALL)};
  color: ${theme.palettes.brand.primary};
  flex-shrink: 0;
  line-height: 1 !important;
  font-weight: bold;
`;

export const innerSavingBox: ThemedFunctor = ({ theme }) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    justify-content: center;
    flex-direction: column;
  }
`;

export const savingValue: ThemedFunctor = ({ theme, $compact }) => css`
  ${getTypography(theme, $compact ? TypographyName.H2 : TypographyName.H1)};
  color: ${theme.palettes.brand.primary};
  font-weight: normal;
  text-align: center;
  flex-shrink: 0;
`;

export const logo: ThemedFunctor = ({ theme }) => css`
  color: ${theme.palettes.brand.primary};
  width: 2.5rem;
  flex-shrink: 0;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: 3.5rem;
  }
`;
